import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import ScenarioCard from "@/components/ScenarioCard";
import { SCENARIOS } from "@/constants/testIds";
import { useScenarios } from "@/hooks/useScenarios";
import { CategoryFilterBar } from "@/components/feed/CategoryFilterBar";

export default function Feed() {
  const [category, setCategory] = useState("");
  const { scenarios, loading, vote } = useScenarios(category);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Community Validated</p>
          <h1 className="font-display font-extrabold uppercase text-3xl md:text-4xl text-zinc-950 tracking-tight">Voting Feed</h1>
          <p className="text-zinc-500 text-sm mt-2">Real scenarios. The community decides if it's bias.</p>
        </div>
        <Link to="/submit-scenario" data-testid={SCENARIOS.submitButton}>
          <Button className="bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
            <Plus className="h-4 w-4 mr-2" /> Share a Scenario
          </Button>
        </Link>
      </div>

      <CategoryFilterBar category={category} onChange={setCategory} />

      <div data-testid={SCENARIOS.feedContainer} className="space-y-5">
        {loading && (
          <div className="flex justify-center py-14">
            <div className="h-8 w-8 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin" />
          </div>
        )}
        {!loading && scenarios.length === 0 && (
          <div data-testid={SCENARIOS.emptyState} className="text-center py-14 text-zinc-500">
            No scenarios yet in this category. Be the first to share one.
          </div>
        )}
        {!loading && scenarios.map((s) => (
          <ScenarioCard key={s.id} scenario={s} onVote={vote} />
        ))}
      </div>
    </div>
  );
}
